import { Injectable } from '@angular/core';
import { ToastInfo } from './toast-info';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: ToastInfo[] = [];

  show(body: string) {
    this.toasts.push({ body });
  }

  showError(body: string) {
    this.toasts.push({ body, classname: 'bg-danger text-light', delay: 5000 });
  }

  showSuccess(body: string) {
    this.toasts.push({ body, classname: 'bg-success text-light', delay: 5000 });
  }
  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }
}
